import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NativeSoilPrintRoutingModule } from './native-soil-print-routing.module';
import { NativeSoilPrintTableComponent } from './native-soil-print-table/native-soil-print-table.component';

import { MatTableModule } from '@angular/material/table';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatInputModule } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';


@NgModule({
  declarations: [
    NativeSoilPrintTableComponent
  ],
  imports: [
    CommonModule,
    NativeSoilPrintRoutingModule,
    MatTableModule,
    MatCheckboxModule,
    MatInputModule,
    FormsModule,
    MatButtonModule,
  ]
})
export class NativeSoilPrintModule { }
